import { Controller } from "stimulus"

class ModalController extends Controller {
  static targets = ["modal"]

  open(event) {
    event.preventDefault();
    this.showModal()
    this.modalTarget.addEventListener('click', (e) =>  this.backdropClick(e));
  }

  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.hideModal()
    }
  }

  close(event) {
    event.preventDefault();
    this.hideModal()
  }

  closeWithKeyboard(e) {
    if (e.code === "Escape") {
      this.hideModal()
    }
  }

  showModal() {
    this.modalTarget.showModal();
  }

  hideModal() {
    this.modalTarget.close();
  }
}

export default ModalController;